import "jspdf-autotable";
import { Modal } from "react-bootstrap";
import QRCode from "react-qr-code";
import logo from "../../../img/logo2.png";
import Stepper from "../common/Staper";
import useCreateInvoice from "../hooks/useCreateInvoice";
import "./../css/styles.css";

const CreateInvoice = (props) => {
  const { show, setShowModal, onHide } = props;

  const {
    subtotal,
    subtotalAmount,
    invoiceRef,
    step,
    setStep,
    customerData,
    setCustomerData,
    billingData,
    setBillingData,
    gstIncluded,
    setGstIncluded,
    pdfFile,
    setPdfFile,
    handleCustomerChange,
    handleBillingChange,
    handleItemChange,
    addItem,
    downloadPdf,
    handleRemoveItem,
    handleUpdatebilling,
    handleSubmit,
    steps,
  } = useCreateInvoice({ setShowModal: onHide });

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        scrollable
        backdrop="static"
      >
        <Modal.Header closeButton>
          <h6 class="modal-title">Modal title</h6>
        </Modal.Header>

        <Modal.Body>
          <div className="invoice-container">
            <form Validate onSubmit={handleSubmit}>
              <Stepper steps={steps} currentStep={step} setStep={setStep} />

              {step === 3 && (
                <div className="d-flex justify-content-end gap-2 mt-0">
                  <button
                    className="btn btn-light btn-sm"
                    onClick={() => window.print()}
                  >
                    <i class="bi bi-printer me-2"></i>
                    Print
                  </button>
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={() => downloadPdf()}
                  >
                    <i class="bi bi-download me-2 "></i>
                    Download PDF
                  </button>
                </div>
              )}
              <div
                className="invoice-card mt-2"
                style={{ backgroundColor: "rgb(255,255,255)" }}
                ref={invoiceRef}
                id="invoice"
              >
                {step === 1 && (
                  <>
                    <div className="step-header">
                      <span
                        className="step-badge "
                        style={{ fontSize: "small" }}
                      >
                        1
                      </span>
                      <h2 className="step-title" style={{ fontSize: "medium" }}>
                        Customer Details
                      </h2>
                    </div>
                    <div className="invoice-row">
                      <div className="input-group rounded-start">
                        <label style={{ fontSize: "small" }}>
                          Customer Name *
                        </label>
                        <input
                          className="rounded-start"
                          type="text"
                          name="name"
                          placeholder="Enter customer name"
                          value={customerData.name}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.name === "" &&
                            customerData.phone === ""
                          }
                        />
                      </div>

                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>
                          Email Address *
                        </label>
                        <input
                          className="rounded-start"
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={customerData.email}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.email === "" &&
                            customerData.phone === ""
                          }
                        />
                      </div>
                    </div>
                    <div className="invoice-row">
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>
                          Phone Number *
                        </label>
                        <input
                          className="rounded-start"
                          type="tel"
                          name="phone"
                          placeholder="Enter phone number"
                          value={customerData.phone}
                          onChange={handleCustomerChange}
                          maxLength={10}
                        />
                      </div>
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>
                          GST Number (Optional)
                        </label>
                        <input
                          className="rounded-start"
                          type="text"
                          name="gst"
                          placeholder="Enter GST number"
                          value={customerData.gst}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.gst === "" && customerData.phone === ""
                          }
                        />
                      </div>
                    </div>
                    <div className="invoice-row">
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>Address *</label>
                        <textarea
                          className="rounded-start"
                          name="address"
                          placeholder="Enter address"
                          value={customerData.address}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.address === "" &&
                            customerData.phone === ""
                          }
                        ></textarea>
                      </div>
                    </div>
                    <div className="invoice-row">
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>City *</label>
                        <input
                          className="rounded-start"
                          type="text"
                          name="city"
                          value={customerData.city}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.city === "" &&
                            customerData.phone === ""
                          }
                        />
                      </div>
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>State *</label>
                        <input
                          className="rounded-start"
                          type="text"
                          name="state"
                          value={customerData.state}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.state === "" &&
                            customerData.phone === ""
                          }
                        />
                      </div>
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>Pincode *</label>
                        <input
                          className="rounded-start"
                          type="text"
                          name="pincode"
                          value={customerData.pincode}
                          onChange={handleCustomerChange}
                          disabled={
                            customerData.pincode === "" &&
                            customerData.phone === ""
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
                {step === 2 && (
                  <>
                    <div className="step-header">
                      <span
                        className="step-badge"
                        style={{ fontSize: "small" }}
                      >
                        2
                      </span>
                      <h2 className="step-title" style={{ fontSize: "medium" }}>
                        Billing Details
                      </h2>
                    </div>
                    <div className="invoice-row">
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>
                          Invoice Number *
                        </label>
                        <input
                          className="rounded-start"
                          type="text"
                          name="invoiceNumber"
                          value={billingData.invoiceNumber}
                          onChange={handleBillingChange}
                          disabled
                          placeholder="INV-XXXXXX"
                        />
                      </div>
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>
                          Invoice Date *
                        </label>
                        <input
                          className="rounded-start"
                          type="date"
                          name="invoiceDate"
                          value={billingData.invoiceDate}
                          onChange={handleBillingChange}
                        />
                      </div>
                      <div className="input-group">
                        <label style={{ fontSize: "small" }}>Due Date *</label>
                        <input
                          className="rounded-start"
                          type="date"
                          name="dueDate"
                          value={billingData.dueDate}
                          onChange={handleBillingChange}
                        />
                      </div>
                    </div>

                    <div className="gst-container">
                      <div className="gst-header">
                        <div>
                          <h4
                            className="gst-title"
                            style={{ fontSize: "medium" }}
                          >
                            GST Inclusion
                          </h4>
                          <p
                            className="gst-subtitle"
                            style={{ fontSize: "small" }}
                          >
                            Choose whether the item prices include GST or GST
                            should be added separately
                          </p>
                        </div>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={gstIncluded}
                            onChange={() => setGstIncluded(!gstIncluded)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>

                      <div className="gst-box">
                        <p
                          className="gst-box-title"
                          style={{ fontSize: "medium" }}
                        >
                          GST Additional Mode
                        </p>
                        {gstIncluded ? (
                          <p
                            className="gst-box-description"
                            style={{ fontSize: "small" }}
                          >
                            Item prices include GST. GST will be calculated and
                            added to the total amount.
                          </p>
                        ) : (
                          <p
                            className="gst-box-description"
                            style={{ fontSize: "small" }}
                          >
                            Item prices do not include GST. GST will be
                            calculated and added to the total amount.
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between flex-wrap mt-2 ">
                      <h5
                        className="align-self-center"
                        style={{ fontSize: "medium" }}
                      >
                        Invoice Items
                      </h5>
                    </div>
                    <div className="invoice-card bg-white mt-2 p-0">
                      <div className="row m-1 mb-2">
                        <div className="col-12 col-md-6 col-lg-4">
                          <label
                            className="form-label mb-1"
                            style={{ fontSize: "small" }}
                          >
                            Description *
                          </label>
                          <input
                            className="form-control form-control-sm rounded-start"
                            type="text"
                            placeholder="Item description"
                            name="description"
                            value={billingData.description}
                            onChange={handleBillingChange}
                          />
                        </div>

                        {/* Quantity */}
                        <div className="col-12 col-md-5 col-lg-2">
                          <label
                            className="form-label mb-1"
                            style={{ fontSize: "small" }}
                          >
                            Quantity *
                          </label>
                          <input
                            className="form-control form-control-sm rounded-start"
                            type="number"
                            name="quantity"
                            value={billingData.quantity}
                            onChange={handleBillingChange}
                          />
                        </div>

                        {/* unit_price */}
                        <div className="col-12 col-md-5 col-lg-2">
                          <label
                            className="form-label mb-1"
                            style={{ fontSize: "small" }}
                          >
                            Rate (₹) *
                          </label>
                          <input
                            className="form-control form-control-sm rounded-start"
                            type="number"
                            name="unit_price"
                            value={billingData.unit_price}
                            onChange={handleBillingChange}
                          />
                        </div>

                        {/* Amount */}
                        <div className="col-12 col-md-5 col-lg-2">
                          <label
                            className="form-label mb-1"
                            style={{ fontSize: "small" }}
                          >
                            Amount (₹)
                          </label>
                          <input
                            className="form-control form-control-sm rounded-start"
                            type="text"
                            disabled
                            value={billingData?.amount}
                          />
                        </div>

                        <div
                          className="col-12 col-md-1 align-self-center text-center"
                          style={{
                            cursor: "pointer",
                            marginTop: "31px",
                            fontSize: "20px",
                          }}
                          onClick={addItem}
                        >
                          <i class="bi bi-file-earmark-plus"></i>
                          {/* <i class="bi bi-plus-circle"></i> */}

                          {/* <button className="btn btn-secondary btn-sm"
                                     
                                    > <i class="bi bi-plus-circle"></i></button> */}
                        </div>
                      </div>
                    </div>

                    {billingData.items.length > 0 && (
                      <div className="invoice-card bg-white mt-2">
                        {billingData.items.map((item, index) => (
                          <div className="row m-1 mb-2">
                            <div className="col-12 col-md-6 col-lg-4">
                              <label className="form-label mb-1">
                                Description *
                              </label>
                              <input
                                className="form-control form-control-sm rounded-start"
                                type="text"
                                placeholder="Item description"
                                name="description"
                                value={item.description}
                                onChange={(e) => handleUpdatebilling(e, index)}
                              />
                            </div>

                            {/* Quantity */}
                            <div className="col-12 col-md-5 col-lg-2">
                              <label className="form-label mb-1">
                                Quantity *
                              </label>
                              <input
                                className="form-control form-control-sm rounded-start"
                                type="number"
                                name="quantity"
                                value={item.quantity}
                                onChange={(e) => handleUpdatebilling(e, index)}
                              />
                            </div>

                            {/* unit_price */}
                            <div className="col-12 col-md-5 col-lg-2">
                              <label className="form-label mb-1">
                                Rate (₹) *
                              </label>
                              <input
                                className="form-control form-control-sm rounded-start"
                                type="number"
                                name="unit_price"
                                value={item.unit_price}
                                onChange={(e) => handleUpdatebilling(e, index)}
                              />
                            </div>

                            {/* Amount */}
                            <div className="col-12 col-md-5 col-lg-2">
                              <label className="form-label mb-1">
                                Amount (₹)
                              </label>
                              <input
                                className="form-control form-control-sm rounded-start"
                                type="text"
                                disabled
                                value={item?.amount}
                              />
                            </div>

                            <div
                              className="col-12 col-md-1 align-self-center text-center"
                              style={{
                                cursor: "pointer",
                                marginTop: "32px",
                                fontSize: "20px",
                              }}
                              onClick={() => handleRemoveItem(index)}
                            >
                              <i class="bi bi-trash"></i>

                              {/* <button className="btn btn-secondary btn-sm"
                                            
                                            ></button> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {billingData.items.length > 0 && (
                      <>
                        <div className="table-responsive mt-3">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Rate (₹)</th>
                                <th>Amount (₹)</th>
                                {customerData?.state === "Maharashtra" && (
                                  <>
                                    <th>CGST (9%)</th>
                                    <th>SGST (9%)</th>
                                  </>
                                )}
                                {customerData?.state !== "Maharashtra" && (
                                  <th>IGST (18%)</th>
                                )}

                                <th>Subtotal</th>
                              </tr>
                            </thead>
                            <tbody>
                              {billingData.items.map((item, index) => {
                                const itemRate = !gstIncluded
                                  ? Number(item.unit_price).toFixed(2)
                                  : (item.unit_price / 1.18).toFixed(2);
                                const itemAmount = !gstIncluded
                                  ? item.amount.toFixed(2)
                                  : (item.amount / 1.18).toFixed(2);
                                const cgstAmount = (itemAmount * 0.09).toFixed(
                                  2,
                                );
                                const sgstAmount = (itemAmount * 0.09).toFixed(
                                  2,
                                );
                                const gstAmount = (itemAmount * 0.18).toFixed(
                                  2,
                                );
                                const totalAmount = (
                                  Number(itemAmount) + Number(gstAmount)
                                ).toFixed(2);

                                return (
                                  <tr key={index}>
                                    <td>{item.description}</td>
                                    <td>{item.quantity}</td>
                                    <td>{itemRate}</td>
                                    <td>{itemAmount}</td>
                                    {customerData?.state === "Maharashtra" && (
                                      <>
                                        <td>{cgstAmount}</td>
                                        <td>{sgstAmount}</td>
                                      </>
                                    )}
                                    {customerData?.state !== "Maharashtra" && (
                                      <td>{gstAmount}</td>
                                    )}

                                    <td>{totalAmount}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-flex justify-content-end mt-2">
                          <div className="btn btn-light">
                            <span className="me-2">Subtotal:</span>
                            <strong>₹ {subtotalAmount}</strong>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                {step === 3 && (
                  <>
                    <div>
                      <div className="">
                        <h2
                          className="text-center"
                          style={{ fontSize: "medium" }}
                        >
                          Tax Invoice
                        </h2>
                      </div>
                      <div className="invoice-card bg-white rounded p-4 ">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-3 border-bottom">
                          <div className="mb-5 col-lg-10">
                            <h3
                              className="text-primary fw-bold m-0 mb-3"
                              style={{
                                display: "inline-block",
                                fontSize: "20px",
                              }}
                            >
                              <img
                                src={logo}
                                alt="logo"
                                className="img-fluid"
                                style={{ maxWidth: "150px" }}
                              />
                            </h3>

                            <h5
                              className="fw-bold mb-1"
                              style={{ fontSize: "medium" }}
                            >
                              Krishak Sevita Online Solution Pvt Ltd
                            </h5>
                            <p className="mb-1" style={{ fontSize: "small" }}>
                              123 Business Street
                              <br />
                              Mumbai, Maharashtra 400001
                            </p>
                            <p className="mb-1" style={{ fontSize: "small" }}>
                              GST: 27ABCDE1234F1Z5
                            </p>
                            <p className="mb-1" style={{ fontSize: "small" }}>
                              Email: contact@yourcompany.com
                            </p>
                            <p className="mb-0" style={{ fontSize: "small" }}>
                              Phone: +91 98765 43210
                            </p>
                          </div>

                          <div
                            className=" shadow-sm p-2  bg-body rounded"
                            style={{
                              height: "auto",
                              margin: "0 auto",
                              maxWidth: "100px",
                              width: "50%",
                            }}
                          >
                            <QRCode
                              size={256}
                              style={{
                                height: "auto",
                                maxWidth: "100%",
                                width: "100%",
                              }}
                              value={
                                "https://meratractor-invoices.s3.ap-south-1.amazonaws.com/view/invoice/9409212549/RBL_BANK_Ltd_Invoice__MH_687.pdf"
                              }
                              viewBox={`0 0 256 256`}
                            />
                          </div>
                        </div>

                        <hr style={{ margin: "20px 0" }} />

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-3 border-bottom">
                          <div className="mb-5">
                            <p className="mb-1" style={{ fontSize: "small" }}>
                              Invoice #:{" "}
                              {billingData.invoiceNumber || "INV-XXXXXX"}
                            </p>
                            <p className="mb-1" style={{ fontSize: "small" }}>
                              Date: {billingData.invoiceDate || "DD/MM/YYYY"}
                            </p>
                            <p className="mb-0" style={{ fontSize: "small" }}>
                              Due Date: {billingData.dueDate || "DD/MM/YYYY"}
                            </p>
                          </div>

                          <div className="text-end">
                            <h6
                              className="fw-bold"
                              style={{ fontSize: "small" }}
                            >
                              Bill To:
                            </h6>
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: "small" }}
                            >
                              {customerData.name || "Customer Name"}
                            </p>
                            <p className="mb-0" style={{ fontSize: "small" }}>
                              {customerData.address || "Customer Address"}
                            </p>
                            <p className="mb-0" style={{ fontSize: "small" }}>
                              Email:{" "}
                              {customerData.email || "customer@example.com"}
                            </p>
                            <p className="mb-0" style={{ fontSize: "small" }}>
                              State: {customerData.state || "Maharashtra"}
                            </p>
                            <p className="mb-0" style={{ fontSize: "small" }}>
                              Phone: {customerData.phone || "+918051061619"}
                            </p>
                          </div>
                        </div>

                        <hr />

                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Description</th>
                                <th className="text-end">Qty</th>
                                <th className="text-end">Rate</th>
                                <th className="text-end">Amount</th>
                                {customerData?.state === "Maharashtra" && (
                                  <>
                                    <th>CGST (9%)</th>
                                    <th>SGST (9%)</th>
                                  </>
                                )}
                                {customerData?.state !== "Maharashtra" && (
                                  <th>IGST (18%)</th>
                                )}

                                <th>Subtotal</th>
                              </tr>
                            </thead>
                            <tbody>
                              {billingData.items.map((item, index) => {
                                const itemRate = !gstIncluded
                                  ? Number(item.unit_price).toFixed(2)
                                  : (item.unit_price / 1.18).toFixed(2);
                                const itemAmount = !gstIncluded
                                  ? item.amount.toFixed(2)
                                  : (item.amount / 1.18).toFixed(2);
                                const cgstAmount = (itemAmount * 0.09).toFixed(
                                  2,
                                );
                                const sgstAmount = (itemAmount * 0.09).toFixed(
                                  2,
                                );
                                const gstAmount = (itemAmount * 0.18).toFixed(
                                  2,
                                );
                                const totalAmount = (
                                  Number(itemAmount) + Number(gstAmount)
                                ).toFixed(2);
                                return (
                                  <tr key={index}>
                                    <td>{item.description}</td>
                                    <td className="text-end">
                                      {item.quantity}
                                    </td>
                                    <td className="text-end">₹{itemRate}</td>
                                    <td className="text-end">₹{itemAmount}</td>

                                    {customerData?.state === "Maharashtra" && (
                                      <>
                                        <td>{cgstAmount}</td>
                                        <td>{sgstAmount}</td>
                                      </>
                                    )}
                                    {customerData?.state !== "Maharashtra" && (
                                      <td>{gstAmount}</td>
                                    )}

                                    <td>{totalAmount}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tfoot>
                              <tr>
                                {customerData?.state === "Maharashtra" && (
                                  <>
                                    <th colSpan={6}>Total Amount:</th>
                                    <th> ₹{subtotalAmount.toFixed(1)}</th>
                                  </>
                                )}

                                {customerData?.state !== "Maharashtra" && (
                                  <>
                                    <th colSpan={5}>Total Amount:</th>
                                    <th> ₹{subtotalAmount.toFixed(1)}</th>
                                  </>
                                )}
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                        <hr />

                        <hr />

                        <div className="text-center mt-4">
                          <p className="small text-muted mb-0">
                            Thank you for your business!
                          </p>
                          <p className="small text-muted mb-0">
                            This is a computer-generated invoice and does not
                            require a signature.
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="d-flex gap-2 align-items-center justify-content-between flex-wrap mt-3">
                {step !== 3 && (
                  <button
                    className="btn btn-light btn-sm"
                    style={{
                      width: "auto",
                      backgroundColor: "rgb(255, 255, 255)",
                    }}
                    onClick={() => setStep(1)}
                    disabled={step === 1}
                  >
                    Previous
                  </button>
                )}
                {step === 1 && (
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={() => setStep(2)}
                    disabled={
                      !(
                        customerData?.name !== "" &&
                        customerData?.email !== "" &&
                        customerData?.phone !== "" &&
                        customerData?.address !== "" &&
                        customerData?.city !== "" &&
                        customerData?.state !== "" &&
                        customerData?.pincode !== ""
                      )
                    }
                  >
                    Next
                  </button>
                )}
                {step === 2 && (
                  <button
                    className="btn btn-dark btn-sm"
                    type="submit"
                    disabled={billingData.items.length === 0}
                  >
                    Generate Invoice
                  </button>
                )}
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateInvoice;
